import React, { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import { Page404 } from "../../../pages/page404/Page404";
import { GlobalLoader } from "../../../shared/loaders/globalLoader/GlobalLoader";
import { DashboardLayer } from "../../../shared/dashboardLayer/DashboardLayer";
import AskExpert from "../../../pages/askExpert/AskExpert";
import AskExpertDetails from "../../../pages/askExpert/askExpertDetails/AskExpertDetails";
import Reports from "../../../pages/reports/Reports";
import AuditOnsiteList from "../../../pages/audits/auditOnsiteLIst/AuditOnsiteList";
import AuditOnSite from "../../../pages/audits/auditOnSite/AuditOnSite";

const Checklists = lazy(() => import("../../../pages/checklists/Checklists"));
const Resources = lazy(() => import("../../../pages/resources/Resources"));
const Library = lazy(() => import("../../../pages/library/Library"));
const Employees = lazy(() => import("../../../pages/employees/Employees"));
const Logout = lazy(() => import("../../../pages/auth/logout/Logout"));
const Trainings = lazy(() => import("../../../pages/trainings/Trainings"));
const ChangePassword = lazy(
  () => import("../../../pages/auth/changePassword/ChangePassword")
);
const SingleComment = lazy(
  () => import("../../../pages/audits/actionList/singleComment/SingleComment")
);
const ActionList = lazy(
  () => import("../../../pages/audits/actionList/ActionList")
);
const Action = lazy(() => import("../../../pages/audits/action/Action"));
const Home = lazy(() => import("../../../pages/home/Home"));
const PrivacyPolicy = lazy(
  () => import("../../../pages/privacyPolicy/PrivacyPolicy")
);
const TermsOfUse = lazy(() => import("../../../pages/termsOfUse/TermsOfUse"));

export const RoutesClient = () => {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <DashboardLayer>
            <Suspense fallback={<GlobalLoader />}>
              <Home />
            </Suspense>
          </DashboardLayer>
        }
      />
      <Route
        path="/library"
        element={
          <DashboardLayer>
            <Suspense fallback={<GlobalLoader />}>
              <Library />
            </Suspense>
          </DashboardLayer>
        }
      />
      <Route
        path="/settings"
        element={
          <DashboardLayer>
            <Suspense fallback={<GlobalLoader />}>
              <ChangePassword />
            </Suspense>
          </DashboardLayer>
        }
      />
      <Route
        path="/employees"
        element={
          <DashboardLayer>
            <Suspense fallback={<GlobalLoader />}>
              <Employees />
            </Suspense>
          </DashboardLayer>
        }
      />
      <Route
        path="/trainings"
        element={
          <DashboardLayer>
            <Suspense fallback={<GlobalLoader />}>
              <Trainings />
            </Suspense>
          </DashboardLayer>
        }
      />
      <Route
        path="/controls/check-lists"
        element={
          <DashboardLayer>
            <Suspense fallback={<GlobalLoader />}>
              <Checklists />
            </Suspense>
          </DashboardLayer>
        }
      />
      <Route
        path="/controls/reports"
        element={
          <DashboardLayer>
            <Suspense fallback={<GlobalLoader />}>
              <Reports />
            </Suspense>
          </DashboardLayer>
        }
      />
      <Route
        path="/ask-expert"
        element={
          <DashboardLayer>
            <Suspense fallback={<GlobalLoader />}>
              <AskExpert />
            </Suspense>
          </DashboardLayer>
        }
      />
      <Route
        path="/ask-expert/:id"
        element={
          <DashboardLayer>
            <Suspense fallback={<GlobalLoader />}>
              <AskExpertDetails />
            </Suspense>
          </DashboardLayer>
        }
      />
      <Route
        path="/controls/resources"
        element={
          <DashboardLayer>
            <Suspense fallback={<GlobalLoader />}>
              <Resources />
            </Suspense>
          </DashboardLayer>
        }
      />
      <Route
        path="/audits-onsite"
        element={
          <DashboardLayer>
            <Suspense fallback={<GlobalLoader />}>
              <AuditOnsiteList />
            </Suspense>
          </DashboardLayer>
        }
      />
      <Route
        path="/audits-onsite/:auditOnSiteId"
        element={
          <DashboardLayer>
            <Suspense fallback={<GlobalLoader />}>
              <AuditOnSite />
            </Suspense>
          </DashboardLayer>
        }
      />
      <Route
        path="/action-list"
        element={
          <DashboardLayer>
            <Suspense fallback={<GlobalLoader />}>
              <ActionList />
            </Suspense>
          </DashboardLayer>
        }
      />
      <Route
        path="/action-list/:actionId"
        element={
          <DashboardLayer>
            <Suspense fallback={<GlobalLoader />}>
              <Action />
            </Suspense>
          </DashboardLayer>
        }
      />
      <Route
        path="action-list/:actionId/comment/:commentId"
        element={
          <DashboardLayer>
            <Suspense fallback={<GlobalLoader />}>
              <SingleComment />
            </Suspense>
          </DashboardLayer>
        }
      />
      <Route
        path="/logout"
        element={
          <DashboardLayer>
            <Suspense fallback={<GlobalLoader />}>
              <Logout />
            </Suspense>
          </DashboardLayer>
        }
      />
      <Route
        path="/privacy-policy"
        element={
          <DashboardLayer>
            <Suspense fallback={<GlobalLoader />}>
              <PrivacyPolicy />
            </Suspense>
          </DashboardLayer>
        }
      />
      <Route
        path="/terms-of-use"
        element={
          <DashboardLayer>
            <Suspense fallback={<GlobalLoader />}>
              <TermsOfUse />
            </Suspense>
          </DashboardLayer>
        }
      />
      <Route
        path="/change-password/:token"
        element={
          <Suspense fallback={<GlobalLoader />}>
            <ChangePassword />
          </Suspense>
        }
      />
      <Route
        path="*"
        element={
          <DashboardLayer>
            <Page404 />
          </DashboardLayer>
        }
      />
    </Routes>
  );
};
